import { Amount } from 'nomst/Stores/Decision/amount';

export class ChangeHistoryEmployeeCycleState {
    promotionJobTitle: string;
    amounts: Amount[];
    countryBudgets: ICountryBudget[];

    constructor(
        promotionJobTitle: string,
        amounts: Amount[],
        countryBudgets: ICountryBudget[]) {
        this.promotionJobTitle = promotionJobTitle;
        this.amounts = amounts;
        this.countryBudgets = countryBudgets;
    }
}